import React, { useState } from 'react';

const SCRIPT_TEMPLATE = `请帮我生成一个短视频脚本，要求：
1. 时长控制在60-90秒
2. 包含开场、内容、结尾
3. 分镜头描述具体画面
4. 标注旁白文案
5. 标注背景音乐建议

主题：{topic}`;

const ScriptGeneratorDialog = ({ isOpen, onClose, onSubmit }) => {
  const [topic, setTopic] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!topic.trim()) return;
    onSubmit(SCRIPT_TEMPLATE.replace('{topic}', topic));
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content script-modal">
        <h2>生成短视频脚本</h2>
        <form onSubmit={handleSubmit}>
          <div className="modal-form-group">
            <label>视频主题:</label>
            <input
              type="text"
              value={topic}
              onChange={(e) => setTopic(e.target.value)}
              placeholder="例如：如何培养早起习惯"
              autoFocus
            />
          </div>
          <div className="modal-actions">
            <button type="button" className="cancel-btn" onClick={onClose}>
              取消
            </button>
            <button type="submit" className="confirm-btn">
              生成脚本
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ScriptGeneratorDialog; 